export const copyToClipboard = (textToCopy: string, callback?: () => void): void => {
    navigator.clipboard.writeText(textToCopy);
    if (callback) {
        callback();
    }
};
